<template>
  <div class="increase-edit-padding">
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <!-- 表单 -->
    <a-form v-show="!loading" :form="editForm" @submit="handleSubmit" autocomplete="off">
      <!-- 姓名 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Name"
        hasFeedback
      >
        <a-input
          placeholder="Name"
          v-decorator="[
            'name',
            {rules: [{ required: true, message: 'Please input Name.' }]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 性别 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Gender"
        hasFeedback
      >
        <a-select
          v-decorator="[
            'gender',
            {rules: [{ required: true, message: 'Please select Gender.' }]}
          ]"
        >
          <a-select-option value="M">Male</a-select-option>
          <a-select-option value="F">Female</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 邮箱 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Email"
        hasFeedback
      >
        <a-input
          placeholder="Email"
          v-decorator="[
            'email',
            {rules: [
              { required: true, message: 'Please input Email.' },
              { pattern: /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/, message: 'Invalid email address.'}
            ]}
          ]"
        ></a-input>
      </a-form-item>
      <!-- 生日 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Birthday"
        hasFeedback
      >
        <a-date-picker
          placeholder="Birthday"
          v-decorator="[
            'birthday',
            {rules: [{ required: true, message: 'Please select Birthday.' }]}
          ]"
        ></a-date-picker>
      </a-form-item>
      <!-- 加入日期 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Join Date"
        hasFeedback
      >
        <a-date-picker
          placeholder="Join Date"
          v-decorator="[
            'joinDate',
            {rules: [{ required: true, message: 'Please select oin Date.' }]}
          ]"
        ></a-date-picker>
      </a-form-item>
      <!-- 职位 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Position"
        hasFeedback
      >
        <a-select
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'positionId'
          ]"
        >
          <a-select-option value="">No Select</a-select-option>
          <a-select-option v-for="pos in selectPositions" :key="pos.id" :value="pos.id">{{ (pos.department ? pos.department.name : '') + '-' + pos.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 领导 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Leader"
        hasFeedback
      >
        <a-select
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'leaderId'
          ]"
        >
          <a-select-option value="">No Select</a-select-option>
          <a-select-option v-for="leader in selectLeaders" :key="leader.id" :value="leader.id">{{ leader.name + ' ' + leader.email }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 性别 -->
      <a-form-item
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        label="Status"
        hasFeedback
      >
        <a-select
          v-decorator="[
            'status',
            {rules: [{ required: true, message: 'Please select Status.' }]}
          ]"
        >
          <a-select-option value="1">Serving</a-select-option>
          <a-select-option value="0">Left Job</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 隐藏域 -->
      <a-form-item v-show="false"><a-input v-decorator="['id']"/></a-form-item>
    </a-form>
    <footer-tool-bar>
      <a-button type="primary" html-type="submit" :loading="submitting" @click="handleSubmit">Save</a-button>
      <a-button style="margin-left: 8px;" :loading="submitting" @click="handleGoBack">Cancel</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import EmployeeApi from '@/api/adm/api-employee'
import PositionApi from '@/api/adm/api-position'
import FooterToolBar from '@/components/FooterToolbar'

export default {
  name: 'EmployeeEdit',
  components: {
    FooterToolBar
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      saving: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      createFlag: false,
      // 待选的职位
      selectPositions: [],
      // 待选领导
      selectLeaders: [],
      // 加载中
      loading: true,
      // 提交中
      submitting: false
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      const selectPositions = await this.loadSelectPositions()
      var selectLeaders = await this.loadSelectLeaders()
      var formData = null
      var createFlag = true
      if (data === '') {
        // 新增
        formData = {
          'id': null,
          'name': null,
          'gender': 'M',
          'birthday': null,
          'joinDate': null,
          'email': null,
          'positionId': '',
          'leaderId': '',
          'status': '1'
        }
      } else {
        createFlag = false
        // 编辑
        formData = pick(data, ['id', 'name', 'gender', 'birthday', 'joinDate', 'email', 'positionId', 'leaderId', 'status'])
        formData.birthday = formData.birthday ? moment(formData.birthday) : null
        formData.joinDate = formData.joinDate ? moment(formData.joinDate) : null
        // 从领导列表中过滤掉自己
        if (selectLeaders && selectLeaders.length > 0) {
          selectLeaders = selectLeaders.filter(e => {
            return e.id !== formData.id
          })
        }
      }
      this.selectPositions = selectPositions
      this.selectLeaders = selectLeaders
      this.createFlag = createFlag
      this.editForm.setFieldsValue(formData)
      this.loading = false
    },
    // 读取所有职位
    loadSelectPositions () {
      return new Promise((resolve, reject) => {
        PositionApi.query(Object.assign({ curPage: 1, pageSize: 1000 }))
          .then(res => {
            resolve(res.data.datas)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 读取所有领导
    loadSelectLeaders () {
      return new Promise((resolve, reject) => {
        EmployeeApi.query(Object.assign({ curPage: 1, pageSize: 1000 }))
          .then(res => {
            resolve(res.data.datas)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit (e) {
      this.submitting = true
      e.preventDefault()
      // eslint-disable-next-line
      this.editForm.validateFields((err, fieldsValue) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        formData.parentId = formData.parentId === '' ? null : formData.parentId
        // 添加
        if (formData.id === null) {
          EmployeeApi.add(formData).then(res => {
            this.submitting = false
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Save successfully !')
              this.handleGoBack()
            }
          })
        }
        // 修改
        if (formData.id !== null) {
          EmployeeApi.update(formData.id, formData).then(res => {
            this.submitting = false
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Update successfully !')
              this.handleGoBack()
            }
          })
        }
      })
    }
  }
}
</script>
